package com.volkswagen.vocs.grip.vocstis

import kotlin.String
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
public enum class QuantityUom {
  @SerialName(value = "ea")
  Ea,
  ;

  override fun toString(): String = serializer().descriptor.getElementName(ordinal)
}
